import {
  COLLECTION_LIST_GET,
  COLLECTION_LIST_GET_SUCCESS,
  COLLECTION_LIST_GET_ERROR,
  CREATE_COLLECTION,
  CREATE_COLLECTION_SUCCESS,
  CREATE_COLLECTION_ERROR,
  GET_COLLECTION,
  GET_COLLECTION_SUCCESS,
  GET_COLLECTION_ERROR,
  SET_PAGE_VIEW,
  DELETE_COLLECTION,
  DELETE_COLLECTION_SUCCESS,
  DELETE_COLLECTION_ERROR,
  GET_COLLECTION_COURSE_LIST,
  GET_COLLECTION_COURSE_LIST_SUCCESS,
  GET_COLLECTION_COURSE_LIST_ERROR,
  COURSE_DELETE,
  COURSE_DELETE_SUCCESS,
  COURSE_DELETE_ERROR,
  EDIT_COURSE_COLLECTION_INDEX,
  EDIT_COURSE_COLLECTION_INDEX_SUCCESS,
  EDIT_COURSE_COLLECTION_INDEX_ERROR,
  COURSE_CLONE,
  COURSE_CLONE_SUCCESS,
  COURSE_CLONE_ERROR,
  COURSE_TRANSLATE,
  COURSE_TRANSLATE_SUCCESS,
  COURSE_TRANSLATE_ERROR,
  COURSE_TRANSLATION_COMPLETE,
  GET_COLLECTION_SETTINGS,
  GET_COLLECTION_SETTINGS_SUCCESS,
  GET_COLLECTION_SETTINGS_ERROR,
  PATCH_COURSE_COLLECTION,
  PATCH_COURSE_COLLECTION_SUCCESS,
  PATCH_COURSE_COLLECTION_ERROR,
  PATCH_COLLECTION_SETTINGS,
  PATCH_COLLECTION_SETTINGS_SUCCESS,
  PATCH_COLLECTION_SETTINGS_ERROR,
  PATCH_PRICE,
  PATCH_PRICE_SUCCESS,
  PATCH_PRICE_ERROR,
  PATCH_COLLECTION_PAYMENT_MESSAGES,
  PATCH_COLLECTION_PAYMENT_MESSAGES_SUCCESS,
  PATCH_COLLECTION_PAYMENT_MESSAGES_ERROR,
  GET_COLLECTION_LANDING_PAGE,
  GET_COLLECTION_LANDING_PAGE_SUCCESS,
  GET_COLLECTION_LANDING_PAGE_ERROR,
  PATCH_COLLECTION_LANDING_PAGE,
  PATCH_COLLECTION_LANDING_PAGE_SUCCESS,
  PATCH_COLLECTION_LANDING_PAGE_ERROR,
  INVITE_COLLABORATOR,
  INVITE_COLLABORATOR_SUCCESS,
  INVITE_COLLABORATOR_ERROR,
  GET_COLLECTION_COLLABORATORS_LIST,
  GET_COLLECTION_COLLABORATORS_LIST_SUCCESS,
  GET_COLLECTION_COLLABORATORS_LIST_ERROR,
  UPDATE_COLLECTION_COLLABORATOR,
  UPDATE_COLLECTION_COLLABORATOR_SUCCESS,
  UPDATE_COLLECTION_COLLABORATOR_ERROR,
  DELETE_COLLECTION_COLLABORATOR,
  DELETE_COLLECTION_COLLABORATOR_SUCCESS,
  DELETE_COLLECTION_COLLABORATOR_ERROR,
  FILTER_COLLABORATION_COLLECTION_LIST,
  FILTER_COLLABORATION_COLLECTION_LIST_SUCCESS,
  FILTER_COLLABORATION_COLLECTION_LIST_ERROR,
  ACCEPT_INVITATION_COLLABORATION,
  ACCEPT_INVITATION_COLLABORATION_SUCCESS,
  ACCEPT_INVITATION_COLLABORATION_ERROR,
  SET_VIEW_MODE,
  DELETE_COLLECTION_INVITATION,
  DELETE_COLLECTION_INVITATION_SUCCESS,
  DELETE_COLLECTION_INVITATION_ERROR,
  COLLECTION_SHOWCASE,
  COLLECTION_SHOWCASE_SUCCESS,
  COLLECTION_SHOWCASE_ERROR,
  SET_COLLECTION_TAGS,
  SET_COLLECTION_TAGS_SUCCESS,
  SET_COLLECTION_TAGS_ERROR,
  COLLECTION_DUPLICATING,
  COLLECTION_DUPLICATION_COMPLETE,
} from './type'

export const getCollectionList = (query, callback) => {
  return {
    type: COLLECTION_LIST_GET,
    payload: { query, callback },
  }
}

export const getCollectionListSuccess = data => {
  return {
    type: COLLECTION_LIST_GET_SUCCESS,
    payload: data,
  }
}

export const getCollectionListError = () => {
  return {
    type: COLLECTION_LIST_GET_ERROR,
  }
}

/**
 *
 * @param {*} entity
 * @param {*} callback
 */
export const createCollectionAction = (entity, callback) => {
  return {
    type: CREATE_COLLECTION,
    payload: { entity, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const createCollectionSuccess = response => {
  return {
    type: CREATE_COLLECTION_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const createCollectionError = () => {
  return {
    type: CREATE_COLLECTION_ERROR,
  }
}

export const getCollection = (id, callback) => {
  return {
    type: GET_COLLECTION,
    payload: { id, callback },
  }
}

export const getCollectionSuccess = response => {
  return {
    type: GET_COLLECTION_SUCCESS,
    payload: response,
  }
}

export const getCollectionError = () => {
  return {
    type: GET_COLLECTION_ERROR,
  }
}

export const setPageView = pageView => {
  return {
    type: SET_PAGE_VIEW,
    payload: pageView,
  }
}

export const deleteCollection = (id, callback) => {
  return {
    type: DELETE_COLLECTION,
    payload: { id, callback },
  }
}

export const deleteCollectionSuccess = response => {
  return {
    type: DELETE_COLLECTION_SUCCESS,
    payload: response,
  }
}

export const deleteCollectionError = () => {
  return {
    type: DELETE_COLLECTION_ERROR,
  }
}

export const getCollectionCourseList = (id, callback) => {
  return {
    type: GET_COLLECTION_COURSE_LIST,
    payload: { id, callback },
  }
}

export const getCollectionCourseListSuccess = response => {
  return {
    type: GET_COLLECTION_COURSE_LIST_SUCCESS,
    payload: response,
  }
}

export const getCollectionCourseListError = () => {
  return {
    type: GET_COLLECTION_COURSE_LIST_ERROR,
  }
}

/**
 *
 * @param {*} entity
 * @param {*} callback
 */
export const courseDeleteAction = (id, callback) => {
  return {
    type: COURSE_DELETE,
    payload: { id, callback },
  }
}

/**
 *
 * @param {*} entity
 */
export const courseDeleteSuccess = response => {
  return {
    type: COURSE_DELETE_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const courseDeleteError = () => {
  return {
    type: COURSE_DELETE_ERROR,
  }
}

/**
 *
 * @param {*} entity
 */
export const editCourseCollectionIndexAction = (entity, callback) => {
  return {
    type: EDIT_COURSE_COLLECTION_INDEX,
    payload: { entity, callback },
  }
}

/**
 *
 * @param {*} entity
 */
export const editCourseCollectionIndexSuccess = entity => {
  return {
    type: EDIT_COURSE_COLLECTION_INDEX_SUCCESS,
    payload: { entity },
  }
}

/**
 *
 */
export const editCourseCollectionIndexError = () => {
  return {
    type: EDIT_COURSE_COLLECTION_INDEX_ERROR,
  }
}

/**
 *
 * @param {*} code
 * @param {*} callback
 */
export const courseCloneAction = (code, callback, history) => {
  return {
    type: COURSE_CLONE,
    payload: { code, callback, history },
  }
}

/**
 *
 * @param {*} entity
 */
export const courseCloneSuccess = entity => {
  return {
    type: COURSE_CLONE_SUCCESS,
    payload: { entity },
  }
}

/**
 *
 */
export const courseCloneError = () => {
  return {
    type: COURSE_CLONE_ERROR,
  }
}

/**
 *
 * @param {*} id
 * @param {*} callback
 */
export const getCollectionSettingsAction = (id, callback) => {
  return {
    type: GET_COLLECTION_SETTINGS,
    payload: { id, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const getCollectionSettingsSuccess = response => {
  return {
    type: GET_COLLECTION_SETTINGS_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const getCollectionSettingsError = () => {
  return {
    type: GET_COLLECTION_SETTINGS_ERROR,
  }
}

/**
 *
 * @param {*} content
 * @param {*} callback
 */
export const patchCourseCollectionAction = (content, callback) => {
  return {
    type: PATCH_COURSE_COLLECTION,
    payload: { content, callback },
  }
}

/**
 *
 * @param {*} content
 */
export const patchCourseCollectionSuccess = content => {
  return {
    type: PATCH_COURSE_COLLECTION_SUCCESS,
    payload: { content },
  }
}

export const patchCourseCollectionError = () => {
  return {
    type: PATCH_COURSE_COLLECTION_ERROR,
  }
}

/**
 *
 * @param {*} content
 * @param {*} callback
 * @param {*} onError optional; lets a caller roll its own state back when the
 * patch is rejected, on top of the generic error snackbar
 */
export const patchCollectionSettingsAction = (content, callback, onError) => {
  return {
    type: PATCH_COLLECTION_SETTINGS,
    payload: { content, callback, onError },
  }
}

/**
 *
 * @param {*} content
 */
export const patchCollectionSettingsSuccess = content => {
  return {
    type: PATCH_COLLECTION_SETTINGS_SUCCESS,
    payload: { content },
  }
}

/**
 *
 */
export const patchCollectionSettingsError = () => {
  return {
    type: PATCH_COLLECTION_SETTINGS_ERROR,
  }
}
/**
 *
 * @param {*} content
 * @param {*} callback
 */
export const patchPriceAction = (id, data, callback) => {
  return {
    type: PATCH_PRICE,
    payload: { id, data, callback },
  }
}

/**
 *
 * @param {*} content
 */
export const patchPriceSuccess = content => {
  return {
    type: PATCH_PRICE_SUCCESS,
    payload: { content },
  }
}

/**
 *
 */
export const patchPriceError = () => {
  return {
    type: PATCH_PRICE_ERROR,
  }
}

export const patchCollectionPaymentMessagesAction = (
  collectionId,
  content,
  callback,
) => ({
  type: PATCH_COLLECTION_PAYMENT_MESSAGES,
  payload: { collectionId, content, callback },
})

export const patchCollectionPaymentMessagesSuccess = content => ({
  type: PATCH_COLLECTION_PAYMENT_MESSAGES_SUCCESS,
  payload: { content },
})

export const patchCollectionPaymentMessagesError = error => ({
  type: PATCH_COLLECTION_PAYMENT_MESSAGES_ERROR,
  payload: { error },
})
/**
 *
 */
export const getCollectionLandingPageAction = (id, callback) => {
  return {
    type: GET_COLLECTION_LANDING_PAGE,
    payload: { id, callback },
  }
}

export const getCollectionLandingPageSuccess = response => {
  return {
    type: GET_COLLECTION_LANDING_PAGE_SUCCESS,
    payload: { response },
  }
}

export const getCollectionLandingPageError = () => {
  return {
    type: GET_COLLECTION_LANDING_PAGE_ERROR,
  }
}

export const patchCollectionLandingPageAction = (id, data, callback) => {
  return {
    type: PATCH_COLLECTION_LANDING_PAGE,
    payload: { id, data, callback },
  }
}

export const patchCollectionLandingPageSuccess = (response, collectionId) => {
  return {
    type: PATCH_COLLECTION_LANDING_PAGE_SUCCESS,
    payload: { response, collectionId },
  }
}

export const patchCollectionLandingPageError = () => {
  return {
    type: PATCH_COLLECTION_LANDING_PAGE_ERROR,
  }
}

/**
 *
 * @param {*} code
 * @param {*} targetLanguage
 * @param {*} callback
 */
export const courseTranslateAction = (code, targetLanguage, callback, history) => {
  return {
    type: COURSE_TRANSLATE,
    payload: { code, targetLanguage, callback, history },
  }
}

/**
 *
 * @param {*} entity
 */
export const courseTranslateSuccess = entity => {
  return {
    type: COURSE_TRANSLATE_SUCCESS,
    payload: { entity },
  }
}

/**
 *
 */
export const courseTranslateError = () => {
  return {
    type: COURSE_TRANSLATE_ERROR,
  }
}


export const inviteCollaboratorAction = (id, data, callback) => {
  return {
    type: INVITE_COLLABORATOR,
    payload: { id, data, callback },
  }
}

export const inviteCollaboratorSuccess = response => {
  return {
    type: INVITE_COLLABORATOR_SUCCESS,
    payload: { response },
  }
}

export const inviteCollaboratorError = () => {
  return {
    type: INVITE_COLLABORATOR_ERROR,
  }
}

export const getCollectionCollaboratorsListAction = (id, query, callback) => {
  return {
    type: GET_COLLECTION_COLLABORATORS_LIST,
    payload: { id, query, callback },
  }
}

export const getCollectionCollaboratorsListSuccess = response => {
  return {
    type: GET_COLLECTION_COLLABORATORS_LIST_SUCCESS,
    payload: { response },
  }
}

export const getCollectionCollaboratorsListError = () => {
  return {
    type: GET_COLLECTION_COLLABORATORS_LIST_ERROR,
  }
}

export const updateCollectionCollaboratorAction = (
  id,
  userId,
  data,
  callback,
) => {
  return {
    type: UPDATE_COLLECTION_COLLABORATOR,
    payload: { id, userId, data, callback },
  }
}

export const updateCollectionCollaboratorSuccess = (userId, data) => {
  return {
    type: UPDATE_COLLECTION_COLLABORATOR_SUCCESS,
    payload: { userId, data },
  }
}

export const updateCollectionCollaboratorError = () => {
  return {
    type: UPDATE_COLLECTION_COLLABORATOR_ERROR,
  }
}

export const deleteCollectionCollaboratorAction = (id, userId, callback) => {
  return {
    type: DELETE_COLLECTION_COLLABORATOR,
    payload: { id, userId, callback },
  }
}

export const deleteCollectionCollaboratorSuccess = response => {
  return {
    type: DELETE_COLLECTION_COLLABORATOR_SUCCESS,
    payload: { response },
  }
}

export const deleteCollectionCollaboratorError = () => {
  return {
    type: DELETE_COLLECTION_COLLABORATOR_ERROR,
  }
}

export const filterCollaborationsAction = (query, callback) => {
  return {
    type: FILTER_COLLABORATION_COLLECTION_LIST,
    payload: { query, callback },
  }
}

export const filterCollaborationsSuccess = response => {
  return {
    type: FILTER_COLLABORATION_COLLECTION_LIST_SUCCESS,
    payload: { response },
  }
}

export const filterCollaborationsError = () => {
  return {
    type: FILTER_COLLABORATION_COLLECTION_LIST_ERROR,
  }
}

export const acceptInvitationCollaborationAction = (code, callback) => {
  return {
    type: ACCEPT_INVITATION_COLLABORATION,
    payload: { code, callback },
  }
}

export const acceptInvitationCollaborationSuccess = response => {
  return {
    type: ACCEPT_INVITATION_COLLABORATION_SUCCESS,
    payload: { response },
  }
}

export const acceptInvitationCollaborationError = () => {
  return {
    type: ACCEPT_INVITATION_COLLABORATION_ERROR,
  }
}

export const setViewModeAction = viewMode => {
  return {
    type: SET_VIEW_MODE,
    payload: viewMode,
  }
}

export const deleteCollectionInvitationAction = (id, email, callback) => {
  return {
    type: DELETE_COLLECTION_INVITATION,
    payload: { id, email, callback },
  }
}

export const deleteCollectionInvitationSuccess = response => {
  return {
    type: DELETE_COLLECTION_INVITATION_SUCCESS,
    payload: { response },
  }
}

export const deleteCollectionInvitationError = () => {
  return {
    type: DELETE_COLLECTION_INVITATION_ERROR,
  }
}

export const collectionShowcaseAction = (data, callback) => {
  return {
    type: COLLECTION_SHOWCASE,
    payload: { data, callback },
  }
}

export const collectionShowcaseSuccess = response => {
  return {
    type: COLLECTION_SHOWCASE_SUCCESS,
    payload: { response },
  }
}

export const collectionShowcaseError = () => {
  return {
    type: COLLECTION_SHOWCASE_ERROR,
  }
}

export const courseTranslationCompleteAction = id => {
  return {
    type: COURSE_TRANSLATION_COMPLETE,
    payload: { id },
  }
}

export const setCollectionTagsAction = (
  collectionId,
  tagIds,
  resolvedTags,
  callback,
) => ({
  type: SET_COLLECTION_TAGS,
  payload: { collectionId, tagIds, resolvedTags, callback },
})

export const setCollectionTagsSuccess = (collectionId, tags) => ({
  type: SET_COLLECTION_TAGS_SUCCESS,
  payload: { collectionId, tags },
})

export const setCollectionTagsError = () => ({
  type: SET_COLLECTION_TAGS_ERROR,
})

/**
 * Marks the (newly created) clone as "duplicating" while its courses are cloned
 * in the background. `id` is the new collection's id.
 */
export const collectionDuplicatingAction = id => ({
  type: COLLECTION_DUPLICATING,
  payload: { id },
})

/**
 * Clears the "duplicating" state once the background clone finishes (SignalR event).
 */
export const collectionDuplicationCompleteAction = id => ({
  type: COLLECTION_DUPLICATION_COMPLETE,
  payload: { id },
})

